
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UserModule } from '@/store/modules/user';

import DialogCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import DialogSelectDevice from '@/components/DeviceSelectDialog/index.vue';
import DialogSelectEvent from './selectEvent.vue';
import DialogSelectCheck from './selectCheck.vue';

const validOptions = [
  {
    value: "1",
    label: "有效",
  },
  {
    value: "2",
    label: "无效",
  },

];

@Component({
  name: "selectPollingSearchItem",
  components: {
    DialogSelectDevice,
    DialogSelectEvent,
    DialogCustomer,
    DialogSelectCheck,
  },
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => {}
  })
  searchData!: any;

  private validOptions = validOptions;

  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, start]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private companyId=UserModule.getCompanyId
  private deviceVisible = false
  private confirmDeviceHandle(val:any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }
  private deviceClose(v: boolean) {
    this.deviceVisible = v;
  }
  private deviceReadonly = false
  @Watch("deviceVisible")
  getDeviceVisible(val: boolean) {
    if (val) {
      this.deviceReadonly = true;
    } else {
      this.deviceReadonly = false;
    }
  }
  //事件
  private eventReadonly = false
  @Watch("dialogSelectEventVisible")
  getEventVisible(val: boolean) {
    if (val) {
      this.eventReadonly = true;
    } else {
      this.eventReadonly = false;
    }
  }
  private dialogSelectEventVisible= false
  private dialogSelectEvent(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }

  private closeSelectEvent(val: any) {
    this.dialogSelectEventVisible = val;
  }
  //检查项
  private checkReadonly = false
  @Watch("dialogSelectCheckVisible")
  getCheckVisible(val: boolean) {
    if (val) {
      this.checkReadonly = true;
    } else {
      this.checkReadonly = false;
    }
  }
  private dialogSelectCheckVisible= false
  private dialogSelectCheck(val: any) {
    this.searchData.fields = {};
    this.searchData.fields.name = val.name;
    this.searchData.fields.id = val.id;
    this.changeData();
  }

  private closeSelectCheck(val: any) {
    this.dialogSelectCheckVisible = val;
  }


  private customerReadonly = false
  @Watch("customerVisible")
  getCustomerVisible(val: boolean) {
    if (val) {
      this.customerReadonly = true;
    } else {
      this.customerReadonly = false;
    }
  }
  private customerVisible = false
  private customerConfirm(val:any) {
    this.searchData.fields = val;
    // this.searchData.fields.name = val.name;
    // this.searchData.fields.id = val.id;
    this.changeData();
  }
  private closeCustomerHandle(val: any) {
    this.customerVisible = val;
  }

  private clearInput() {
    this.searchData.fields = {};
    this.searchData.fields.name = '';
    this.searchData.fields.id = '';
    this.changeData();
  }

  private changeData() {
    this.$emit('receiveData', this.searchData);
  }

  private keyupHandle() {
    this.$emit('receiveData', this.searchData, true);
  }
}
